import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import { MAX_PAGE_HEIGHT } from '../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  forgotPasswordWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: MAX_PAGE_HEIGHT,
  },
  forgotPasswordContentWrapper: {
    borderRadius: '4px',
    backgroundColor: theme.palette.background.paper,
    width: '480px',
    padding: '16px',
  },
  forgotPasswordForm: {
    width: '100%',
  },

  backToLogin: {
    textAlign: 'center',
    width: '100%',
    marginTop: '32px',
    fontWeight: 400,
    fontSize: '12px',
  },
  forgotPasswordSubmitButton: {
    marginTop: '32px',
  },
  backToLoginButton: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    marginLeft: '4px',
  },
  sentIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '16px',

    '& svg': {
      color: theme.palette.primary.main,
      fontSize: '96px',
    },
  },
}));
